import React, { Component } from "react";

import {
  postComment,
  postCommentRecommendaton
} from "../../../helper/comment_helper";

import LocalizedStrings from "react-localization";
import en from "../../../localization/localization-en.json";

import UserImage from "../../user_image";

import VideoPlayer from "../../video_player";
import CreateRecommendationLink from "../../create_recommendation/create_recommendation_link";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faLink } from "@fortawesome/free-solid-svg-icons";

import { validateURL, checkImageUrl } from "../../../helper/helper";
import { renderErrorMessage } from "../../../helper/user_helper";

import TextareaAutosize from "react-textarea-autosize";

let strings = new LocalizedStrings({ en });

class ListComment extends Component {
  state = {
    comment: "",
    image: null,
    video: null,
    imageFile: null,
    videoFile: null,
    sendUrl: false,
    url: "",
    url_title: "",
    url_description: "",
    loaded: true,
    errors: ""
  };

  componentWillUnmount() {
    if (this.checkUrlCall) {
      this.checkUrlCall.cancel();
    }
  }

  render() {
    if (this.props.user === null) {
      // If user not login we don't let user ability to post
      return <div />;
    }

    const htmlFor = "image-upload" + this.props.question.id;
    return (
      <div className="row max_width_500 pt-2 pb-5">
        <div className="width_image_question" style={{ alignItems: "unset" }}>
          <div style={{ marginTop: "1px" }}>
            <UserImage user={this.props.user} />
          </div>
        </div>
        <div className="width_text_question width_text_question_reset width_text_align_answer">
          <div
            className="comment_only"
            style={{
              borderRadius: "10px",
              height: "100%"
            }}
          >
            <div style={{ position: "relative" }}>
              {this.renderImage()}
              {this.renderUrl()}
            </div>
            {this.renderRequestUrl()}
            {renderErrorMessage(this.state.errors)}
            <TextareaAutosize
              placeholder={strings.add_comment}
              type="text"
              onChange={this.handleChangeComment}
              value={this.state.comment}
              style={{
                textAlign: "left",
                width: "calc(100% - 60px)",
                marginTop: "2px",
                backgroundColor: "transparent",
                border: "none",
                resize: "none"
              }}
            />
            <label
              htmlFor={htmlFor}
              style={{
                display: "inline-block",
                paddingLeft: 0,
                paddingRight: 0,
                position: "relative",
                top: "-8px"
              }}
            >
              <FontAwesomeIcon
                className="yaystack_icon_navBar cursor_btn"
                icon={faCamera}
                style={{ marginRight: "10px" }}
              />
              <input
                type="file"
                className="input-file "
                accept="video/mp4,video/quicktime,image/*"
                id={htmlFor}
                name="image-upload"
                onChange={this.handleChangeImage}
              />
            </label>
            <FontAwesomeIcon
              className="yaystack_icon_navBar cursor_btn"
              icon={faLink}
              style={{ marginRight: "5px", position: "relative", top: "-8px" }}
              onClick={this.clickUrl}
            />
          </div>
        </div>
        <div
          className="width_image_question"
          style={{ flexDirection: "column-reverse" }}
        >
          {this.renderPost()}
        </div>
      </div>
    );
  }

  renderPost() {
    if (this.state.loaded === false) {
      return <div />;
    }

    const style = {
      display: "block",
      position: "absolute",
      margin: "0px",
      width: "calc(100% - 2px)", // Remove 2px for matching white border of image user
      height: "calc(100% - 2px)", // Remove 2px for matching white border of image user
      top: "0px",
      left: "0px"
    };
    const style_image = {
      left: "0px",
      bottom: "0px",
      flex: "unset"
    };

    return (
      <div className="user_img" style={style_image}>
        <button
          style={style}
          className="btn btn_primary btn_yaystack no_border"
          onClick={this.handlerPostComment}
        >
          <label className="cursor_btn" style={{ textTransform: "capitalize" }}>
            {strings.post}
          </label>
        </button>
      </div>
    );
  }

  renderImage() {
    if (this.state.image == null) {
      if (this.state.video == null) {
        return <div />;
      }
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        muted: true,
        loop: true,
        playsInline: true,
        sources: [
          {
            src: this.state.video,
            type: "video/mp4"
          }
        ]
      };
      return <VideoPlayer {...videoJsOptions} createPage={true} />;
    }

    return <img src={this.state.image} alt="upload" />;
  }

  renderUrl() {
    if (this.state.sendUrl === true && this.state.url_title) {
      return (
        <div className="div_url">
          <label className="url_title">{this.state.url_title}</label>
          <label className="url_description">
            {this.state.url_description}
          </label>
        </div>
      );
    }
  }

  renderRequestUrl() {
    if (this.state.sendUrl === false) {
      return <div />;
    }
    return (
      <CreateRecommendationLink
        url={this.state.url}
        handleChangeURL={this.handleChangeURL}
      />
    );
  }

  clickUrl = event => {
    event.preventDefault();
    const sendUrl = !this.state.sendUrl;
    this.setState({ sendUrl });
  };

  handleChangeComment = event => {
    this.setState({ comment: event.target.value });
  };

  handleChangeURL = url => {
    this.setState({ url, url_title: "", url_description: "" });
    if (this.checkUrlCall) {
      this.checkUrlCall.cancel();
    }

    if (!url.includes("http://") && !url.includes("https://")) {
      url = "http://" + url;
    }

    if (this.state.imageFile === null && this.state.videoFile === null) {
      this.setState({ image: null });
    }
    if (validateURL(url)) {
      const self = this;
      this.checkUrlCall = checkImageUrl(url);
      this.checkUrlCall.promise
        .then(answer => {
          if (self.state.imageFile === null && self.state.videoFile === null) {
            self.setState({
              image: answer.image
            });
          }
          self.setState({
            url_title: answer.title,
            url_description: answer.description
          });
        })
        .catch(error => {
          self.setState({ errors: error.errors });
        });
    }
  };

  handleChangeImage = event => {
    const errors = "";
    this.setState({ errors });

    if (event.target.files && event.target.files[0]) {
      this.setState({
        image: null,
        imageFile: null,
        video: null,
        videoFile: null
      });
      if (event.target.files[0].type.includes("image/")) {
        let reader = new FileReader();
        reader.onload = e => {
          this.setState({
            image: e.target.result
          });
        };
        this.setState({ imageFile: event.target.files[0] });
        reader.readAsDataURL(event.target.files[0]);
      } else if (event.target.files[0].type.includes("video/")) {
        let reader = new FileReader();
        reader.onload = e => {
          this.setState({
            video: e.target.result
          });
        };
        this.setState({ videoFile: event.target.files[0] });
        reader.readAsDataURL(event.target.files[0]);
      } else {
        // Check format as accept is not working on edge
        const errors = strings.wrong_file;
        this.setState({ errors });
      }
    }
  };

  handlerPostComment = event => {
    event.preventDefault();

    const errors = "";
    this.setState({ errors });

    // Checking minimum length of the answer
    if (this.state.comment.length < 1) {
      const errors = "Your comment is too short.";
      this.setState({ errors });
      return;
    }

    // Checking that the recommendation doesn't have any URL
    if (
      this.state.comment.includes("http://") ||
      this.state.comment.includes("https://") ||
      this.state.comment.includes("ftp://") ||
      this.state.comment.includes("www.")
    ) {
      const errors = strings.url_not_allow;
      this.setState({ errors });
      return;
    }

    if (this.state.url !== "") {
      // Validate URL
      if (!validateURL(this.state.url)) {
        const errors = strings.wrong_url;
        this.setState({ errors });
        return;
      }
    }

    // // Checking if video or image present
    // if (this.state.image === null && this.state.video === null) {
    //   const errors = strings.recommendation_img_or_video_missing;
    //   this.setState({ errors });
    //   return;
    // }

    // Checking maximum size video (100MB)
    if (this.state.video !== null) {
      if (this.state.videoFile) {
        if (this.state.videoFile.size > 100 * 1024 * 1024) {
          const errors = strings.media_too_big;
          this.setState({ errors });
          return;
        }
      } else {
        return;
      }
    }

    // Checking maximum size image (100MB)
    if (this.state.image !== null) {
      if (this.state.imageFile) {
        if (this.state.imageFile.size > 100 * 1024 * 1024) {
          const errors = strings.media_too_big;
          this.setState({ errors });
          return;
        }
      } else {
        if (this.state.url) {
          // If image present (meta data image) and url we will create the image from the meta data on the backend side
        } else {
          return;
        }
      }
    }

    const loaded = false;
    this.setState({ loaded });
    var fd = new FormData();

    if (this.props.question) {
      fd.append("answer[name]", this.state.comment);
      if (this.state.image !== null && this.state.imageFile !== null) {
        fd.append("answer[image]", this.state.imageFile);
      }
      if (this.state.video !== null && this.state.videoFile !== null) {
        fd.append("answer[video]", this.state.videoFile);
      }
      if (this.state.url !== "") {
        var url = this.state.url;
        if (!url.includes("http://") && !url.includes("https://")) {
          url = "http://" + url;
        }
        fd.append("answer[url]", url);
      }
      this.userCommentCall = postComment(
        this.props.question.id,
        fd,
        this.props.list
      );
    } else if (this.props.recommendation) {
      fd.append("comment[name]", this.state.comment);
      this.userCommentCall = postCommentRecommendaton(
        this.props.recommendation.id,
        fd
      );
    } else {
      return;
    }

    const self = this;
    this.userCommentCall.promise
      .then(res => {
        self.setState({
          answer: res.answer,
          loaded: true,
          errors: "",
          comment: "",
          image: null,
          video: null,
          imageFile: null,
          videoFile: null,
          sendUrl: false,
          url: "",
          url_title: "",
          url_description: ""
        });
        if (res.answer !== null) {
          self.props.addAnswer(res.answer, self.props.question);
        }
      })
      .catch(error => {
        self.setState({ errors: error.errors, loaded: true });
      });
  };
}

export default ListComment;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_comment.jsx